function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "accounts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Union 15",
    d: "M1.5 18a1.441 1.441 0 0 1-1.054-.446A1.441 1.441 0 0 1 0 16.5V3.75a.724.724 0 0 1 .216-.534A.729.729 0 0 1 .753 3a.721.721 0 0 1 .534.216.729.729 0 0 1 .213.534V16.5h12.75a.75.75 0 1 1 0 1.5zm2.882-2.993a1.335 1.335 0 0 1-.976-.413 1.335 1.335 0 0 1-.413-.976V1.39a1.335 1.335 0 0 1 .413-.977A1.335 1.335 0 0 1 4.382 0H16.61a1.335 1.335 0 0 1 .976.413A1.335 1.335 0 0 1 18 1.39v12.228a1.412 1.412 0 0 1-1.39 1.39zm2.762-4.061a9.735 9.735 0 0 0-2.762 1.838v.834H16.61v-.834a9.734 9.734 0 0 0-2.762-1.838 8.149 8.149 0 0 0-3.352-.691 8.148 8.148 0 0 0-3.352.691zm1.33-7.007a2.789 2.789 0 0 0-.841 2.05 2.871 2.871 0 0 0 2.89 2.89 2.871 2.871 0 0 0 2.89-2.89 2.871 2.871 0 0 0-2.89-2.89 2.789 2.789 0 0 0-2.049.84z",
    transform: "translate(3 3)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.ac98578740df3b709b9c562ff621d2a7.svg";
export { ForwardRef as ReactComponent };